import React, { useState, useEffect } from "react";
import "./Gallery.css";

const projectCategories = {
  "2D Detailed Design": {
    Civil: {
      images: [
        {
          src: "/2ddetail/Civil/EMERGENCY OVERHEAD TANK SECTION VIEW.png",
          name: "EMERGENCY OVERHEAD TANK SECTION VIEW",
        },
        {
          src: "/2ddetail/Civil/EMERGENCY OVERHEAD TANK.png",
          name: "EMERGENCY OVERHEAD TANK",
        },
        {
          src: "/2ddetail/Civil/GCP FOUNDATION.png",
          name: "GCP FOUNDATION",
        },
        {
          src: "/2ddetail/Civil/POLY DOSING TANK.png",
          name: "POLY DOSING TANK",
        },
        {
          src: "/2ddetail/Civil/RH MCC ROOM.png",
          name: "RH MCC ROOM",
        },
        {
          src: "/2ddetail/Civil/SECONDARY COOLING TOWER.png",
          name: "SECONDARY COOLING TOWER",
        },
      ],
    },
    Mechanical: {
      images: [
        {
          src: "/2ddetail/mechanical/1.png",
          name: "GCP Mechanical GA Plan",
        },
        {
          src: "/2ddetail/mechanical/2.png",
          name: "Elevation View",
        },
        {
          src: "/2ddetail/mechanical/3.png",
          name: "GCP Mechanical GA Elevation",
        },
        {
          src: "/2ddetail/mechanical/4.png",
          name: "GCP Mechanical GA Plan",
        },
        {
          src: "/2ddetail/mechanical/5.png",
          name: "Chute Fabrication Detail",
        },
        {
          src: "/2ddetail/mechanical/6.png",
          name: "Mechnacial GA of reversible Saddle Conveyor",
        },
      ],
    },
    Electrical: {
      images: [
        {
          src: "/2ddetail/lighting/ga/1.jpg",
          name: "Detail Cable Tray Layout",
        },
        {
          src: "/2ddetail/lighting/ga/3.jpg",
          name: "Detail Cable Tray Layout of ECR",
        },
        {
          src: "/2ddetail/lighting/panel/panel1.jpeg",
          name: "Cable Tray Layout of PLC",
        },
        {
          src: "/2ddetail/lighting/plans/1.jpg",
          name: "Lighting Layout of ECR-1 of Blast Furnace",
        },

        {
          src: "/2ddetail/lighting/6.jpg",
          name: "Lighting Layout of ECR-2 of Blast Furnace",
        },
        {
          src: "/2ddetail/lighting/7.jpg",
          name: "Lighting Layout of  of Blast Furnace",
        },
      ],
    },
    Piping: {
      images: [
        {
          src: "/2ddetail/piping/1.jpg",
          name: "Piping Supporter of Roaster",
        },
        {
          src: "/2ddetail/piping/2.jpg",
          name: "Piping Pump House-1 of Blast Furnace",
        },
        {
          src: "/2ddetail/piping/3.jpg",
          name: "Piping Pump House-2 of Blast Furnace",
        },
        {
          src: "/2ddetail/piping/4.jpg",
          name: "Piping Pump House-1 of Roaster",
        },
        {
          src: "/2ddetail/piping/5.jpg",
          name: "IBR Piping Analysis of Blast Furnace",
        },
      ],
    },
    Structural: {
      images: [
        {
          src: "/2ddetail/Structural/1.png",
          name: "Structural Detail of Stock House",
        },
        {
          src: "/2ddetail/Structural/2.png",
          name: "Structural Detail of Dedusting",
        },
        {
          src: "/2ddetail/Structural/3.png",
          name: "Structural Detail of Pump House",
        },
        {
          src: "/2ddetail/Structural/4.png",
          name: "Structural Detail of Blast Furnace",
        },
        {
          src: "/2ddetail/Structural/5.png",
          name: "Structural Detail of Roaster",
        },
        {
          src: "/2ddetail/Structural/6.png",
          name: "Structural Detail of Fliter Press",
        },
        // {
        //   src: "/2ddetail/structural/7.png",
        //   name: "7",
        // },
        // {
        //   src: "/2ddetail/structural/8.png",
        //   name: "8",
        // },
        // {
        //   src: "/2ddetail/structural/9.png",
        //   name: "9",
        // },
        // {
        //   src: "/2ddetail/structural/10.png",
        //   name: "10",
        // },
      ],
    },
    "General Arrangement": {
      images: [
        {
          src: "/2ddetail/ga/3.png",
          name: "GA of Attachment of Flange",
        },
        {
          src: "/2ddetail/ga/4.png",
          name: "GA of RBF-3",
        },
        {
          src: "/2ddetail/ga/5.png",
          name: "Overall GA of Screen Building",
        },
        {
          src: "/2ddetail/ga/6.png",
          name: "Overall GA of Crusher House",
        },
        {
          src: "/2ddetail/ga/7.png",
          name: "Crusher House of GA",
        },
        {
          src: "/2ddetail/ga/8.png",
          name: "Screen Building of GA",
        },
        // {
        //   src: "/2ddetail/ga/7.jpg",
        //   name: "7",
        // },
        // {
        //   src: "/2ddetail/ga/8.jpg",
        //   name: "8",
        // },
        // {
        //   src: "/2ddetail/ga/9.jpg",
        //   name: "9",
        // },
      ],
    },
  },
  "3D Modeling": {
    Civil: {
      images: [
        // {
        //   src: "/3dmodeling/civil/9.png",
        //   name: "9",
        //   description: "Image from Civil segment",
        // },
        // {
        //   src: "/3dmodeling/civil/10.png",
        //   name: "10",
        //   description: "Image from Civil segment",
        // },
        // {
        //   src: "/3dmodeling/civil/11.png",
        //   name: "11",
        //   description: "Image from Civil segment",
        // },
        // {
        //   src: "/3dmodeling/civil/12.png",
        //   name: "12",
        //   description: "Image from Civil segment",
        // },
        // {
        //   src: "/3dmodeling/civil/13.png",
        //   name: "13",
        //   description: "Image from Civil segment",
        // },

        // {
        //   src: "/3dmodeling/civil/17.png",
        //   name: "17",
        //   description: "Image from Civil segment",
        // },
        // {
        //   src: "/3dmodeling/civil/18.png",
        //   name: "18",
        //   description: "Image from Civil segment",
        // },
        // {
        //   src: "/3dmodeling/civil/19.png",
        //   name: "19",
        //   description: "Image from Civil segment",
        // },
        // {
        //   src: "/3dmodeling/civil/20.png",
        //   name: "20",
        // },
        // {
        //   src: "/3dmodeling/civil/21.png",
        //   name: "21",
        // },
        // {
        //   src: "/3dmodeling/civil/22.png",
        //   name: "22",
        // },
        // {
        //   src: "/3dmodeling/civil/23.png",
        //   name: "23",
        // },
        // {
        //   src: "/3dmodeling/civil/24.png",
        //   name: "24",
        // },
        // {
        //   src: "/3dmodeling/civil/25.jpg",
        //   name: "25",
        // },
        // {
        //   src: "/3dmodeling/civil/26.png",
        //   name: "26",
        // },
        // {
        //   src: "/3dmodeling/civil/27.jpg",
        //   name: "27",
        // },
        // {
        //   src: "/3dmodeling/civil/28.jpg",
        //   name: "28",
        // },
        // {
        //   src: "/3dmodeling/civil/29.jpg",
        //   name: "29",
        // },
        // {
        //   src: "/3dmodeling/civil/30.jpg",
        //   name: "30",
        // },
        {
          src: "/3dmodeling/civil/ADMIN 2.png",
          name: "ADMIN Building of Blast Furnace",
        },
        {
          src: "/3dmodeling/civil/ADMIN.png",
          name: "ADMIN Building of Roaster",
        },
        {
          src: "/3dmodeling/civil/CASTER ECR.png",
          name: "CASTER ECR",
        },
        {
          src: "/3dmodeling/civil/DG ELECTRICAL ROOM.png",
          name: "DG ELECTRICAL ROOM",
        },
        {
          src: "/3dmodeling/civil/FILTER PRESS BULILDING.png",
          name: "FILTER PRESS BULILDING",
        },
        {
          src: "/3dmodeling/civil/LCSS 4.png",
          name: "LCSS ",
        },
        {
          src: "/3dmodeling/civil/MAIN CONTROLL ROOM.png",
          name: "MAIN CONTROLL ROOM",
        },
        {
          src: "/3dmodeling/civil/PUMP HOUSE ELECTRICAL BUILDING PILE LAYOUT.jpg",
          name: "PUMP HOUSE ELECTRICAL BUILDING PILE LAYOUT",
        },
        {
          src: "/3dmodeling/civil/RAMP B.png",
          name: "RAMP B",
        },
        {
          src: "/3dmodeling/civil/RCPH Chemical.jpg",
          name: "RCPH Chemical",
        },
        {
          src: "/3dmodeling/civil/SA STORAGE TANK.jpg",
          name: "SA STORAGE TANK",
        },
        {
          src: "/3dmodeling/civil/SGP WATER TANK AD PUMP HOUSE.jpg",
          name: "SGP WATER TANK AD PUMP HOUSE",
        },
        {
          src: "/3dmodeling/civil/URFO BUILDING.jpg",
          name: "URFO BUILDING",
        },
      ],
    },
    Architectural: {
      images: [
        {
          src: "/3d/articurtural/1.jpg",
          name: "LOD 500 Architectural Building",
        },
        {
          src: "/3d/articurtural/2.jpg",
          name: "RHMCC Building",
        },
        {
          src: "/3d/articurtural/3.jpg",
          name: "LOD 400 Architectural Building",
        },
        {
          src: "/3d/articurtural/4.jpg",
          name: "Pump House of Blast Furnace",
        },
      ],
    },
    Structural: {
      images: [
        {
          src: "/3dmodeling/structural/2.png",
          name: "Blast Furnace-2",
        },
        {
          src: "/3dmodeling/structural/3.png",
          name: "Saga Sahi Process Building",
        },
        {
          src: "/3dmodeling/structural/4.png",
          name: "Conyeyor Gallery",
        },
        {
          src: "/3dmodeling/structural/6.png",
          name: "Inter Plant Conyeyor Gallery",
        },
        {
          src: "/3dmodeling/structural/9.png",
          name: "Inter Plant Conyeyor Gallery",
        },
        {
          src: "/3dmodeling/structural/16.png",
          name: "Inter Plant Conyeyor Gallery",
        },
      ],
    },
    Electrical: {
      images: [
        {
          src: "/3dmodeling/electrical/1.png",
          name: "Illumination Calculation of ECR-1 Blast Furnace",
        },
        {
          src: "/3dmodeling/electrical/2.png",
          name: "Illumination Calculation of ECR-2 Blast Furnace",
        },
        {
          src: "/3dmodeling/electrical/3.png",
          name: "Illumination Calculation of PLC Blast Furnace",
        },
        {
          src: "/3dmodeling/electrical/4.png",
          name: "Illumination Calculation of Main ECR ",
        },
        {
          src: "/3dmodeling/electrical/5.png",
          name: "Illumination Calculation of PLC Blast Furnace",
        },
        {
          src: "/3dmodeling/electrical/6.png",
          name: "Illumination Calculation of PLC Blast Furnace",
        },
        // {
        //   src: "/3dmodeling/electrical/8.png",
        //   name: "8",
        // },
        // {
        //   src: "/3dmodeling/electrical/9.png",
        //   name: "9",
        // },
        // {
        //   src: "/3dmodeling/electrical/10.png",
        //   name: "10",
        // },
        // {
        //   src: "/3dmodeling/electrical/11.png",
        //   name: "11",
        // },
        // {
        //   src: "/3dmodeling/electrical/12.png",
        //   name: "12",
        // },
      ],
    },
    Piping: {
      images: [
        {
          src: "/3dmodeling/piping/1.png",
          name: "Industrial Water Piping",
        },
        {
          src: "/3dmodeling/piping/2.png",
          name: "Pump House Piping of Blast Furnace",
        },
        // {
        //   src: "/3dmodeling/piping/10.png",
        //   name: "",
        // },
        // {
        //   src: "/3dmodeling/piping/13.png",
        //   name: "",
        // },
        {
          src: "/3dmodeling/piping/14.png",
          name: "Fire Water Piping",
        },
        // {
        //   src: "/3dmodeling/piping/19.png",
        //   name: "19",
        // },
        {
          src: "/3dmodeling/piping/20.png",
          name: "Rack Piping",
        },
        // {
        //   src: "/3dmodeling/piping/21.png",
        //   name: "21",
        // },
        {
          src: "/3dmodeling/piping/25.png",
          name: "Inter Plant Piping",
        },
        {
          src: "/3dmodeling/piping/39.png",
          name: "saga Sahi Piping",
        },
      ],
    },
  },
};

const Gallery = () => {
  const [category, setCategory] = useState("2D Detailed Design");
  const [segment, setSegment] = useState(
    Object.keys(projectCategories["2D Detailed Design"])[0]
  );
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    if (category && projectCategories[category]) {
      const segments = Object.keys(projectCategories[category]);
      setSegment(segments[0]);
    }
  }, [category]);

  const filteredImages =
    category && segment && projectCategories[category][segment]
      ? projectCategories[category][segment].images.filter((image) =>
          image.name.toLowerCase().includes(searchTerm.toLowerCase())
        )
      : [];

  return (
    <div className="gallery-container">
      <div className="gallery-header">
        <p className="gallery-subtitle gradient-text">
          Explore our portfolio of 2D and 3D engineering designs
        </p>
      </div>

      <div className="navigation-container">
        <div className="category-tabs">
          {Object.keys(projectCategories).map((cat) => (
            <button
              key={cat}
              className={`category-tab ${cat === category ? "active" : ""}`}
              onClick={() => setCategory(cat)}
            >
              <span className="gradient-text">{cat}</span>
              {cat === category && <span className="active-indicator"></span>}
            </button>
          ))}
        </div>

        {category && (
          <div className="segment-pills">
            {Object.keys(projectCategories[category]).map((seg) => (
              <button
                key={seg}
                className={`segment-pill ${seg === segment ? "active" : ""}`}
                onClick={() => setSegment(seg)}
              >
                <span className="gradient-text">{seg}</span>
              </button>
            ))}
          </div>
        )}
      </div>

      <div className="gallery-grid">
        {filteredImages.map((image, index) => (
          <div key={index} className="gallery-card">
            <div className="image-container">
              <img src={image.src} alt={image.name} loading="lazy" />
              <div className="image-overlay">
                <h3 className="gradient-text">{image.name}</h3>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Gallery;
